import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { MemberSubmission } from '../../../models/submissions/member-submission';
import { EpEmployerSubmission } from '../../../models/submissions/employer-submissions/ep-employer-submission';
import { SubmissionStatusIdEnum } from '../../../models/enum/shared/submission-status-id.enum';

@Pipe({
  name: 'submissionStatusDate'
})
export class SubmissionStatusDatePipe implements PipeTransform {
  private locale = inject(LOCALE_ID);

  transform(submission: MemberSubmission | EpEmployerSubmission): string {
    if (!submission) return '';
    const dateFormat = `MMM d, y 'at' h:mm a`;
    switch (submission.statusId) {
      case SubmissionStatusIdEnum.Completed:
        return submission.completedDate ? formatDate(submission.completedDate, dateFormat, this.locale) : '';
      default:
        return submission.lastStatusUpdateDate
          ? formatDate(submission.lastStatusUpdateDate, dateFormat, this.locale)
          : '';
    }
  }
}
